<template>
  <section class="car-class-list-container">
    <div class="header">
      <div class="filter">
        <div class="statis-tip">
          <span class="inline-block fs-14 color-tip"><span class="fs-24">{{classNum}}</span> Insurer Classes</span>
        </div>
        <div class="flex">
          <div class="item">
            <span class="item_name">Insurer</span>
            <v-select
              v-model="filter.insurer"
              :list="carClassInsureList"
              @change="filterData"></v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="formData">
        <div
          v-for="(item,index) in formData.list"
          :key="index"
          class="flex-box">
          <div class="flex flex-align-center">
            <span class="company-logo">
              <img
                :src="item.company_logo"
                alt="company_logo">
            </span>
            <span class="fs-16 fw-700">{{item.title}}</span>
          </div>
          <div class="form-half-240">
            <div
              v-for="(item_b,index_b) in item.details"
              :key="'item_b'+index_b"
              class="form-item">
              <el-form-item>
                <v-input
                  v-model="item_b.grade"
                  disabled/>
              </el-form-item>
            </div>
          </div>
          <!--          <v-button-->
          <!--            gray-->
          <!--            icon="plus"-->
          <!--            @click="handleAdd(index,index_b)">Add Class</v-button>-->
        </div>
      </el-form>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {mapActions, mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
import {getCarClassList, updateCarClass} from '@api/privateCarList'

export default {
  name: 'manage-class',
  components:{
  },
  mixins: [MixinOptions,MixinRules],
  props:{
    classId:{
      type:Number,
      default:11
    }
  },
  data () {
    return {
      filter: {
        insurer:'',
      },
      pageConfig: {
        currentPage: 1,
        total: 10,
      },
      tableData: [],
      classNum:0,
      makeNum:0,
      modelNum:0,
      formData:{
        list:[]
      }
    }
  },
  computed:{
  },
  watch:{
  },
  mounted(){
    this.getList()
  },
  methods: {
    handleAdd(index,index1){
      let {list} = this.formData
      list[index].details.push({grade:''})
    },
    handleUpdate(){
      this.$refs['form'].validate((valid,rules) => {
        if(valid){
          this.network().updateCarClass()
        }else {
          this.scrollToValidDom(rules)
        }
      })
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.getList()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.getList()
    },
    handleExport(){
      this.is_export = 1
      this.getList()
    },
    getList(){
      let params = {
        ...this.filter,
        page: this.pageConfig.currentPage,
      }
      this.network().getCarClassList(params)
    },
    network(){
      return {
        getCarClassList: async(params) =>{
          params = {
            ...params,
            class_id: this.classId,
            ...this.filter
          }
          const {data} = await getCarClassList(params)
          this.formData.list = data.data
          this.classNum = data.insurer_count
          this.pageConfig.total = data.total
        },
        updateCarClass: async(params) =>{
          let {list} = this.formData||{}
          params = {
            list,
            class_id:this.classId
          }
          const {data} = await updateCarClass(params)
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
        },
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../assets/css/car-class-list';
.fw-700{
  font-weight: 700;
}
.company-logo{
  width: 95px;
  margin-right: 15px;
  img{
    width: 95px;
  }
}
.fs-16{
  font-size: 16px;
}
.flex-box{
  padding: 20px 0;
  border-bottom: 1px solid #E1E4E8;
}
.form-half-240{
  width: 240px;
  margin-top: 15px;
}
</style>
